import { render } from "./BusinessProject.vue?vue&type=template&id=df529342"
import script from "./BusinessProject.vue?vue&type=script&lang=js"
export * from "./BusinessProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__